import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useCallback, useEffect, useRef, useState } from "react"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjcCore from "@grapecity/wijmo"
import dateUtil, { 当月一覧生成, 月一覧 } from "../../ts/util/dateUtil"
import { useSelector } from "react-redux"
import { RootState } from "../../globalStore/rootreducer"
import dayjs from "dayjs"
import { Button } from "react-bootstrap"

const 年号一覧 = dateUtil.create年号西暦一覧()

/**
 * 和暦のpicker付日付入力
 * @returns
 */
const WarekiPicker: React.FC<{
  value: string | null | undefined
  setValue: (value: string | null | undefined) => unknown
  outerStyle?: React.CSSProperties
  isReadOnly?: boolean
}> = (props) => {
  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)
  const calenderButtonRef = useRef<HTMLDivElement>(null)

  //#region [state]
  // 初期値は営業年度もしくは2000年
  const [西暦, set西暦] = useState<number>()
  const [月, set月] = useState<number>()
  const [日一覧, set日一覧] = useState<{ key: string; value: number }[]>(
    当月一覧生成(営業日)
  )
  const [日, set日] = useState<number>()

  const [popup, setPopup] = useState<wjcInput.Popup>()
  const [西暦listbox, set西暦Listbox] = useState<wjcInput.ListBox>()
  const [月listbox, set月Listbox] = useState<wjcInput.ListBox>()
  const [日listbox, set日Listbox] = useState<wjcInput.ListBox>()

  ////#endregion

  //#region [method]

  const popupInitialized = (control: wjcInput.Popup) => {
    control.owner = calenderButtonRef.current
    setPopup(control)
  }
  const 西暦listboxInitialized = (control: wjcInput.ListBox) => {
    control.showSelection(false)
    set西暦Listbox(control)
  }
  const 月listboxInitialized = (control: wjcInput.ListBox) => {
    control.showSelection(false)
    set月Listbox(control)
  }

  const 日listboxInitialized = (control: wjcInput.ListBox) => {
    control.showSelection(false)
    set日Listbox(control)
  }

  //#endregion

  useEffect(() => {
    // 初期props.valueはないが入力はされているときは営業日利用、それもなければ当日利用
    const refDayjs = 営業日 ? dayjs(営業日) : dayjs()
    const refDate = new Date(西暦 ?? refDayjs.year(), 月 ?? refDayjs.month(), 1)
    set日一覧(当月一覧生成(refDate))
  }, [西暦, 月, 営業日])

  const popUpShown = useCallback(() => {
    西暦listbox?.showSelection(false)
    月listbox?.showSelection(false)
    日listbox?.showSelection(false)
  }, [西暦listbox, 月listbox, 日listbox])

  const popUpShowing = useCallback(
    (control: wjcInput.Popup, event: wjcCore.CancelEventArgs) => {
      event.cancel = props.isReadOnly ?? false
    },
    [props.isReadOnly]
  )

  useEffect(() => {
    // 値がない場合は営業日、それもない場合は当日
    const refDayjs =
      props.value && dayjs(props.value).isValid()
        ? dayjs(props.value)
        : dayjs(営業日 ?? "")

    set西暦(refDayjs.year())
    set月(refDayjs.month())
    set日一覧(当月一覧生成(refDayjs.toDate()))
    set日(refDayjs.date())
    西暦listbox?.showSelection(false)
    月listbox?.showSelection(false)
    日listbox?.showSelection(false)
  }, [props.value, 西暦listbox, 月listbox, 日listbox, popup, 営業日])

  useEffect(() => {
    if (西暦listbox && popup && 月listbox) {
      popup.shown.removeAllHandlers()
      popup.shown.addHandler(popUpShown)
    }
  }, [西暦listbox, popUpShown, 月listbox, 日listbox, popup])

  useEffect(() => {
    if (popup && popUpShowing) {
      popup.showing.removeAllHandlers()
      popup.showing.addHandler(popUpShowing)
    }
  }, [popUpShowing, popup])

  return (
    <>
      <div
        ref={calenderButtonRef}
        className="wj-input-group border "
        style={
          props.outerStyle ?? {
            height: "100%",
            width: "2.5rem",
            minHeight: "2rem",
            paddingTop: "0.5rem",
          }
        }>
        <div className="text-center">
          <span className="w-100 h-100 m-1">
            <FontAwesomeIcon
              style={{ fontSize: "1.5rem" }}
              icon={faCalendarAlt}></FontAwesomeIcon>
          </span>
        </div>
      </div>
      <wjrInput.Popup
        showTrigger={wjcInput.PopupTrigger.Click}
        hideTrigger={wjcInput.PopupTrigger.Blur}
        shown={popUpShown}
        initialized={popupInitialized}>
        <table className="wareki-input-table">
          <thead>
            <tr>
              <td>年</td>
              <td>月</td>
              <td>日</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="w-12rem">
                <wjrInput.ListBox
                  selectedValuePath={"西暦"}
                  selectedValue={西暦}
                  displayMemberPath="displayMemberPath"
                  initialized={西暦listboxInitialized}
                  selectedIndexChanged={(control: wjcInput.ListBox) => {
                    const selectedItem: {
                      西暦: number
                      和暦: string
                      displayMemberPath: string
                    } = control.selectedItem
                    set西暦(selectedItem?.西暦)
                  }}
                  itemsSource={年号一覧}></wjrInput.ListBox>
              </td>
              <td className="w-4rem">
                <wjrInput.ListBox
                  selectedValuePath={"value"}
                  selectedValue={月}
                  displayMemberPath="key"
                  initialized={月listboxInitialized}
                  selectedIndexChanged={(control: wjcInput.ListBox) => {
                    const selectedItem: { key: string; value: number } =
                      control.selectedItem
                    control.showSelection(false)
                    set月(selectedItem?.value)
                  }}
                  itemsSource={月一覧}></wjrInput.ListBox>
              </td>
              <td className="w-4rem">
                <wjrInput.ListBox
                  selectedValuePath={"value"}
                  selectedValue={日}
                  displayMemberPath="key"
                  initialized={日listboxInitialized}
                  selectedIndexChanged={(control: wjcInput.ListBox) => {
                    const selectedItem: { key: string; value: number } =
                      control.selectedItem
                    control.showSelection(false)
                    set日(selectedItem?.value)
                  }}
                  itemsSource={日一覧}></wjrInput.ListBox>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                <Button
                  onClick={() => {
                    // 未入力の場合営業日を使う
                    const oldValueDayjs = props.value
                      ? dayjs(props.value)
                      : dayjs()
                    const newValue = new Date(
                      西暦 ?? oldValueDayjs.year(),
                      月 ?? oldValueDayjs.month(),
                      日 ?? oldValueDayjs.date()
                    )
                    props.setValue(newValue.toISOString())
                    popup?.hide()
                  }}>
                  反映
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </wjrInput.Popup>
    </>
  )
}

export default WarekiPicker
